import { ItemList } from '../types/main';
import { Item } from '../types/items';

export const stripItems = <T extends Item>({ items, ...itemListMeta }: ItemList<T>): ItemList<T> => ({
  ...itemListMeta,
  items: [],
});
